import { IFooterMenuItem, ILegalLinks, ISocialIconProps } from '@web_opxp/components';
import { urlPool } from '@web_opxp/features';
import { ELanguage, LanguageService } from '@web_opxp/language';
import { HistoryService } from 'web_core_library';
import ENV from './env';

export function getFooterMenu(session?: string) {
  const t = LanguageService.getTFunction();
  const language = LanguageService.getLanguage();

  const footerMenuItems: IFooterMenuItem[] = [
    {
      title: t('common.common:Footer.Menu.Effectiveness') || ' ',
      link: HistoryService.getEffectivenessUrl(language ?? 'de'),
    },
    {
      title: t('common.common:Footer.Menu.Help') || ' ',
      link: urlPool.getZendeskUrl(language ?? 'de', session),
    },
    {
      title: t('common.common:Footer.Menu.Blog'),
      link: language ? HistoryService.getBlogUrl(language) : '',
    },
  ];

  if (language === ELanguage.English || language === ELanguage.German) {
    footerMenuItems.push({
      title: t('common.common:Footer.Menu.Jobs'),
      link: language ? HistoryService.getJobsUrl() : '',
      target: '_blank',
    });
  }

  if (language === ELanguage.German) {
    footerMenuItems.push({
      title: t('common.common:Footer.Menu.GroupPackage'),
      link: language ? HistoryService.getExternalUrl(`${ENV.OnboardingAppPath}/lp/corp`).toString() : '',
    });
  }

  return footerMenuItems;
}

export function getFooterSocialItems(hideMobile = false) {
  const t = LanguageService.getTFunction();
  const getLink = (fileName: string) => `${ENV.AssetsBaseUrl}/feature/icons/${fileName}`;

  const socialBarItems: ISocialIconProps[] = [
    {
      title: t('common.common:Footer.Social.Facebook'),
      link: 'https://www.facebook.com/NeuroNation/',
      iconSrc: getLink('si-01.png'),
    },
    {
      title: t('common.common:Footer.Social.Twitter'),
      link: 'https://www.twitter.com/NeuroNation/',
      iconSrc: getLink('si-02.png'),
    },
  ];
  if (!hideMobile) {
    socialBarItems.push({
      title: t('common.common:Footer.Social.Apple'),
      link: 'https://app.adjust.com/pa7bvk?campaign=organic',
      iconSrc: getLink('si-03.png'),
    });
    socialBarItems.push({
      title: t('common.common:Footer.Social.Android'),
      link: 'https://app.adjust.com/pa7bvk?campaign=organic',
      iconSrc: getLink('si-04.png'),
    });
  }
  return socialBarItems;
}

export function getLegalLinks() {
  const t = LanguageService.getTFunction();
  const language = LanguageService.getLanguage();
  const touTitle = t('common.common:Footer.Legals.Tou');
  const touSrc = `${ENV.AuthBaseUrl}/legals/tou/?lang=${language}&theme=opxp`;
  const policyTitle = t('common.common:Footer.Legals.Privacy');
  const policySrc = `${ENV.AuthBaseUrl}/legals/dataprivacy/?lang=${language}&theme=opxp`;
  const imprintTitle = t('common.common:Footer.Legals.Impressum');
  const imprintSrc = `${ENV.AuthBaseUrl}/legals/imprint/?lang=${language}&theme=opxp`;
  const legalLinks: ILegalLinks = {
    imprint: { title: imprintTitle, src: imprintSrc },
    policy: { title: policyTitle, src: policySrc },
    tou: { title: touTitle, src: touSrc },
  };
  return legalLinks;
}
